import type { SVGProps } from 'react';
import ArrowSiderIconSvg from '@assets/icons/chevron-back-sider.svg';
import { BaseDivider, BaseSiderLayout } from '@components';
import { BORDER_COLORS, SURFACE_COLORS } from '@constants/colors.ts';
import styled from 'styled-components';

export const SiderContent = styled.div`
    padding: 32px 16px 16px;

    height: 100%;
    display: flex;
    flex-direction: column;

    flex: 1;
    min-height: 0;
    overflow-y: auto;
`;

export const BaseDividerWrapper = styled(BaseDivider)`
    margin: -8px 0 10px 0;
    border-top-color: #409bdb !important;
`;

export const SiderLayoutWrapper = styled(BaseSiderLayout)`
    max-width: 220px !important;
    position: sticky;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;

    top: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;

    /* WebKit */
    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-track {
        background: ${SURFACE_COLORS.disabled};
        border-radius: 48px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${SURFACE_COLORS.disabled};
        border-radius: 48px;
    }

    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: ${SURFACE_COLORS.disabled} transparent;
`;

export const SiderTriggerIconWrapper = styled.div`
    width: 22px;
    height: 40px;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    z-index: 1;

    border-radius: 0 8px 8px 0;
    background: rgba(64, 155, 219, 0.4);
    color: ${BORDER_COLORS.white};
    cursor: pointer;
`;

export const SiderToggleIcon = styled(ArrowSiderIconSvg)<{ $rotated: boolean } & SVGProps<SVGSVGElement>>`
    cursor: pointer;
    transition: transform 0.3s ease;
    transform: rotate(${(props) => (props.$rotated ? '180deg' : '0deg')});
`;
